import { ToolBtn } from "../ToolBtn";
import secondaryComponents from "../..";
import { useCheckoutCustomer } from "./useCheckoutCustomer";
import { AddCustomerToCheckout } from "./AddCustomerToCheckout";

export const CheckoutCustomer = ({ btnStyle = {} }) => {
  const { customerInfo, isActive, setIsActive } = useCheckoutCustomer();

  return (
    <>
      <div className="w-100">
        <ToolBtn
          text="Customer"
          borderColor={"transparent"}
          onClick={() => setIsActive(true)}
          style={btnStyle}
          contentText={
            customerInfo?.customerName ? customerInfo?.customerName : null
          }
        />
      </div>
      <secondaryComponents.Modal
        isActive={isActive}
        width={550}
        closeModal={() => {
          setIsActive(false);
        }}
      >
        <AddCustomerToCheckout closeModal={() => setIsActive(false)} />
      </secondaryComponents.Modal>
    </>
  );
};
